const InventoryStatus = Object.freeze({
  InAccReview: 1,
  Active: 2,
  Disposed: 3,
  NonAccReview: 4,
  Pending: 5,
});
export default InventoryStatus;
